import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateVerificationEditingRequest } from "services";

import { GET_FARM_DATA_SUBMISSION_STATUS, GET_VERIFICATION_EDITING_REQUESTS, UPDATE_VERIFICATION_EDITING_REQUEST } from "consts";

export const useUpdateVerificationEditingRequest = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_VERIFICATION_EDITING_REQUEST],
    mutationFn: ({ requestId, userComment }: { requestId: string; userComment: string }) => updateVerificationEditingRequest({ id: requestId, userComment }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_VERIFICATION_EDITING_REQUESTS, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DATA_SUBMISSION_STATUS, farmId] });
    },
  });
};
